import React, { HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';

import { SmallLoader } from 'shared/components/loading';

type ButtonProps = HTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'reset' | 'submit';
};

export function Button({ children, loading = false, type = 'button', ...rest }: ButtonProps): JSX.Element {
  return (
    <Component type={type} {...rest}>
      {!loading && children}

      {loading && (
        <LoadingState>
          <SmallLoader height={20} color='#fff' />
        </LoadingState>
      )}
    </Component>
  );
}

const Component = styled.button`
  background-color: #4597e0;
  border: none;
  border-radius: 33px;
  color: #fff;
  cursor: pointer;
  font-family: proxima-nova, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  font-size: 13px;
  font-weight: bold;
  height: 33px;
  line-height: 34px;
  min-width: 50px;
  padding: 0 15px;
  position: relative;
  text-transform: uppercase;
  transition: background-color 86ms ease-out;

  :hover {
    background-color: #2c7ec7;
  }

  :focus {
    box-shadow: none;
    outline: none;
  }

  :disabled {
    background-color: #b8b7b7;
    cursor: default;
  }
`;

const LoadingState = styled.div`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;
